import { useRequest, useApplicantAPI } from "@certn/api";
import { ActionListItem, Text, showToast } from "@certn/cascadia-react";
import { Toggle } from "@certn/cascadia-react/components/inputs/toggle/Toggle";
import { useTranslation } from "react-i18next";

export function BetaCommunity() {
  const { t } = useTranslation();
  const request = useRequest();

  const { data, isLoading, mutate } = useApplicantAPI(
    "/api/internal/applicant/me/preferences/"
  );

  const handleToggle = async (joinedBetaCommunityValue: boolean) => {
    try {
      await request(
        "/api/internal/applicant/me/preferences/beta-community/update/",
        {
          method: "POST",
          body: JSON.stringify({
            has_joined_beta_community: joinedBetaCommunityValue,
          }),
        }
      );
      mutate(
        data
          ? { ...data, has_joined_beta_community: joinedBetaCommunityValue }
          : undefined
      );
      showToast(
        joinedBetaCommunityValue
          ? t("Joined Certn beta community")
          : t("Left Certn beta community"),
        {
          type: "info",
        }
      );
    } catch {
      showToast(t("Something went wrong, try again"), {
        type: "error",
      });
    }
  };

  return (
    <ActionListItem
      displayAccessibility
      title={t("Join Certn's beta community")}
      trailing={
        data ? (
          <Toggle
            onChange={handleToggle}
            aria-label={t("Join Certn's beta community")}
            isDisabled={isLoading}
            isSelected={data.has_joined_beta_community}
            testID="beta-community-preferences"
          />
        ) : undefined
      }
    >
      <Text color="text-weak" style="global/body-secondary">
        {t(
          "Get early access to new features and improvements, and share your feedback about the app. "
        )}
      </Text>
    </ActionListItem>
  );
}
